import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02dbd433"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-container" }
const _hoisted_2 = { class: "d-flex container-tabs" }
const _hoisted_3 = { class: "dashboard-tabs" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard-item-header" }, "Faturamento de expedição", -1))
const _hoisted_5 = { class: "filter-date" }
const _hoisted_6 = ["max", "min"]
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "dropdown" }
const _hoisted_9 = {
  class: "btn btn-transparent",
  type: "button",
  id: "dropdownMenuButton1",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_10 = {
  id: "scroll-container",
  class: "d-flex align-items-end"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { id: "scroll-text" }
const _hoisted_13 = { id: "scroll-text" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { style: {"margin-left":"15px"} }
const _hoisted_16 = {
  class: "dropdown-menu dropdown-menu-lg-end",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "dropdown-item" }
const _hoisted_19 = { class: "dashboard-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Tabs, { onAlterBillingUnit: _ctx.alterBillingUnit }, null, 8, ["onAlterBillingUnit"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "month",
          max: _ctx.filters.maxDate,
          min: _ctx.filters.minDate,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.date) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlerDate && _ctx.handlerDate(...args))),
          id: "control-date-date",
          name: "control-date-date",
          class: "input-date"
        }, null, 40, _hoisted_6), [
          [_vModelText, _ctx.filters.date]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              _createElementVNode("button", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.show)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.currentFormattedDate) + " - " + _toDisplayString(_ctx.billingUnit?.name), 1),
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.currentFormattedDate) + " - " + _toDisplayString(_ctx.nextBilling?.name), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.currentFormattedDate) + " - " + _toDisplayString(_ctx.billingUnit?.name), 1)
                      ])),
                  _createElementVNode("span", _hoisted_15, [
                    _createVNode(_component_BaseIcon, {
                      name: "chevron-down-dark",
                      size: "14px"
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("ul", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userBillingUnits, (userBillingUnit) => {
              return (_openBlock(), _createElementBlock("li", {
                key: userBillingUnit.billingUnitCode,
                onClick: ($event: any) => (_ctx.sessionUpdate(userBillingUnit.billingUnitCode))
              }, [
                _createElementVNode("a", _hoisted_18, _toDisplayString(userBillingUnit?.fullName), 1)
              ], 8, _hoisted_17))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_router_view)
    ])
  ]))
}